import React from "react";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div className="footer-left">
          <img className="logo-mark" src="/logo.jpeg" alt="BBI" />
          <span>Beyond Badminton Central Coast</span>
        </div>
        <div className="footer-right">
          <span>© 2026 Beyond Badminton Incorporated</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
